import React from 'react'
import { SlashedIcon } from 'labguard-cdk'

const CriticalAlarmIcon = props => <SlashedIcon icon="hdd" {...props} />

export default CriticalAlarmIcon
